// Zet de vlag `addressStep` of `nameStep` op een aanroep van
// saveQuestionnaireResponse als het onderzoek eerst om het adres
// (Research.AskAddressFirst) of de naam (Research.AskNameFirst) vraagt. De
// server zet dan zelf de respondent op de antwoorden, uit de koppeling van
// deze sessie.
//
// Nodig omdat drie opslagpaden (TopLevelFields, saveQuestionnaireResponses,
// de AI-interviewer) elk hun eigen aanroep bouwen; één helper voorkomt dat er
// één een vlag vergeet — en een vergeten vlag laat antwoorden die ná het
// koppelen binnenkomen voor altijd zonder respondent.
// AI-CONTEXT: See docs/features/adres-koppeling-algemene-qr.md
// AI-CONTEXT: See docs/features/deelnemer-koppeling-algemene-link.md
// AI-CONTEXT: See docs/pitfalls.md#dev-second-source-never-reaches-its-own-gate

/**
 * @typedef {object} LinkedStepFlags
 * @property {*} [addressStep] - `settings.addressStep`; alleen een echte true telt
 * @property {*} [nameStep] - `settings.nameStep`; alleen een echte true telt
 */

/**
 * @template {object} T
 * @param {T} payload - De payload voor saveQuestionnaireResponse
 * @param {LinkedStepFlags} [flags] - Meestal gewoon de settings uit de QuestionnaireContext
 * @returns {T & {addressStep?: true, nameStep?: true}}
 */
const withLinkedStep = (payload, flags) => {
    const addressStep = flags?.addressStep === true
    const nameStep = flags?.nameStep === true
    if (!addressStep && !nameStep) return payload
    return {
        ...payload,
        ...(addressStep ? { addressStep: true } : {}),
        ...(nameStep ? { nameStep: true } : {}),
    }
}

export default withLinkedStep
